import * as React from "react";
import SecNavigationDesktop from "../../../generic/SecNavigation/SecNavigationDesktop";
import { useRouteMatch } from "react-router-dom";
import { ILimitsRouteParams, ILimitsData } from "../../../types/components/limits/limitsTypes";
import LimitsHeader from "../generic/limitsHeader";
import LimitsLeftCol from "../generic/limitsLeftCol";
import LimitsRightCol from "../generic/limitsRightCol";
import "../../../../assets/scss/components/toc/limits/limitsDsk.scss";
import Loader from "../../../generic/loader";
import { IListObj } from "../../../types/genericTypes";
import NoDataContainer from "../../../generic/noDataContainer";

export interface ILimitsLayoutDskProps {
	limitsData: ILimitsData;
	secNavOptions: Array<IListObj>;
	showLoader: boolean;
	tryAgain: () => void;
}

const LimitsLayoutDsk: React.FC<ILimitsLayoutDskProps> = (props) => {
	const routeParams = useRouteMatch<ILimitsRouteParams>();

	return (
		<section className="outer_container container_desk limits">
			<section className="lyCont">
				<section className="list_view">
					<div className="ly_list_view">
						<SecNavigationDesktop defaultValue={routeParams.params.asset || "equity"} list={props.secNavOptions} />
					</div>
					<div className="ly_right_cont">
						{/* If there is header in limitsdata, then we have got api response, otherwise it is still loading */}
						{props.showLoader ? (
							<div className="limits_loader_cont">
								<Loader size={20} color="blue" />
							</div>
						) : props.limitsData.header ? (
							<div className="limits_content">
								<div className="ib col col1">
									<LimitsHeader
										label="Available Limits"
										value={props.limitsData.header?.availableLimits}
										cshAvl={props.limitsData.header?.cshAvl}
										showAddWithdrawBtn
									/>
								</div>

								<div className="ib col col2">
									<LimitsHeader label="Utilised Limits" value={props.limitsData.header?.utilizedLimits} />
								</div>

								<div className="thick_divider" />

								<div className="ib col col1">
									<LimitsLeftCol {...props.limitsData.leftCol} />
								</div>
								<div className="ib col col2">
									<LimitsRightCol {...props.limitsData.rightCol} />
								</div>
							</div>
						) : (
							<NoDataContainer txtHeading="Something Went Wrong" linkDet={{ txt: "Try Again", type: "btn", clickHandler: props.tryAgain }} />
						)}
					</div>
				</section>
			</section>
		</section>
	);
};

export default LimitsLayoutDsk;
